import { __assign, __rest } from '../../../../../../node_modules/tslib/tslib.es6.js';
import React__default from 'react';
import { ZigArrowBottomIconStyled, ZigMenuItemSubHeader } from './styles.js';
import { Check } from '@mui/icons-material';
import { useTheme, useMediaQuery, Box, Typography } from '@mui/material';
import { matchPath, useInRouterContext, Link } from 'react-router-dom';

var SubHeaderMenuButton = function (_a) {
    var route = _a.route, sx = _a.sx, open = _a.open;
    var currentPath = window.location.pathname;
    var label = route.label, routes = route.routes, secondaryTitle = route.secondaryTitle;
    var active = routes === null || routes === void 0 ? void 0 : routes.some(function (x) { return x.active || (x.href && matchPath({ path: x.href }, currentPath)); });
    var theme = useTheme();
    var sm = useMediaQuery(theme.breakpoints.down("sm"));
    return (React__default.createElement(Box, { display: "flex", justifyContent: "space-between", alignItems: "center", gap: "8px", flex: 1, sx: sx },
        React__default.createElement(Box, __assign({ display: "flex", flexDirection: "column" }, (!secondaryTitle && {
            textAlign: "center",
            width: "100%",
        })),
            secondaryTitle && (React__default.createElement(Typography, { color: "neutral400", variant: "caption", component: "p" }, secondaryTitle)),
            React__default.createElement(Typography, { sx: {
                    fontWeight: 400,
                    color: !secondaryTitle ? (active ? "highlighted" : "neutral300") : "neutral100",
                    whiteSpace: sm ? "normal" : "nowrap",
                }, fontWeight: 400, variant: "h3", component: "span" }, label)),
        React__default.createElement(ZigArrowBottomIconStyled, { rotated: open })));
};
var SubHeaderOption = function (_a) {
    var route = _a.route, isSubOption = _a.isSubOption, sx = _a.sx, wrapMenuItem = _a.wrapMenuItem;
    var label = route.label, sideElement = route.sideElement; route.element; route.routes; var href = route.href; route.separator; var optionSx = route.sx, onClick = route.onClick, optionProps = __rest(route, ["label", "sideElement", "element", "routes", "href", "separator", "sx", "onClick"]);
    var routerContext = useInRouterContext();
    var currentPath = window.location.pathname;
    var active = route.active || (route.href && matchPath(route.href, currentPath));
    var propsToAdd = __assign(__assign({ sx: __assign(__assign({}, sx), optionSx), color: active ? "highlighted" : wrapMenuItem ? "neutral300" : "inherit" }, (href &&
        (routerContext
            ? {
                component: Link,
                to: href,
            }
            : { component: "a", href: href }))), optionProps);
    var renderOption = function () { return (React__default.createElement(Box, __assign({ display: "flex", alignItems: "center", gap: "5px", justifyContent: isSubOption ? "space-between" : "center", flex: 1 }, (!wrapMenuItem && propsToAdd)),
        React__default.createElement(Typography, { sx: {
                fontWeight: 400,
                color: "inherit",
            }, variant: "h3", display: "flex", flex: 1, justifyContent: isSubOption ? "flex-start" : "center", alignItems: "center", gap: "5px" },
            label,
            sideElement),
        isSubOption && !!active && React__default.createElement(Check, null))); };
    if (!wrapMenuItem)
        return renderOption();
    return (React__default.createElement(ZigMenuItemSubHeader, __assign({}, propsToAdd, { onClick: onClick, sx: __assign({ color: propsToAdd.color }, propsToAdd.sx), isSubOption: isSubOption }), renderOption()));
};

export { SubHeaderMenuButton, SubHeaderOption };
